module.exports = __webpack_public_path__ + "static/media/puzzle12.9378bb5d.jpg";